import React from 'react';
import c from 'classnames';
import s from './ModalFooter.scss';

interface Props {
  className?: string;
  /**
   * A slot to the left of the footer.
   *
   * We tend to put additional controls or information here, like "Do not show again" checkboxes
   * or disclaimer text.
   */
  left?: React.ReactNode[];

  /**
   * A slot to the right of the footer. Each item passed to this array will be separated by
   * a 24px margin.
   *
   * We tend to put confirm and cancel buttons here.
   */
  right?: React.ReactNode[];
}

/**
 * The bottom portion of a modal. It has slots for it's left and right sides.
 */
const ModalFooter: React.FC<Props> = ({ className, left = [], right = [] }) => {
  return (
    <div className={c(s['root'], className)}>
      <div className={s['left']}>
        {left.map(
          (item, index) =>
            item && (
              <div
                key={`footer-item-${index}`}
                className={s['left-side-item-wrapper']}
              >
                {item}
              </div>
            )
        )}
      </div>
      <div className={s['right']}>
        {right.map(
          (item, index) =>
            item && (
              <div
                key={`footer-item-${index}`}
                className={s['right-side-item-wrapper']}
              >
                {item}
              </div>
            )
        )}
      </div>
    </div>
  );
};
ModalFooter.displayName = 'ModalFooter';

export default ModalFooter;
